import { lazy, Suspense } from "react";
import SeoHead from "@/components/SeoHead";
import HeroSection from "@/components/HeroSection";
import IntroSection from "@/components/IntroSection";
import ProgramsSection from "@/components/ProgramsSection";
import { homeFaqs } from "@/data/homeFaqs";

const ConciergeTravelSection = lazy(() => import("@/components/ConciergeTravelSection"));
const ScienceSection = lazy(() => import("@/components/ScienceSection"));
const SkylineDivider = lazy(() => import("@/components/SkylineDivider"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const CtaBanner = lazy(() => import("@/components/CtaBanner"));
const FaqSection = lazy(() => import("@/components/FaqSection"));
const LocationsSection = lazy(() => import("@/components/LocationsSection"));

const Index = () => {
  return (
    <main>
      <SeoHead
        title="Cardiometabolic Coaching & Luxury Retreats | Wellness Academy"
        description="Science-based cardiometabolic coaching and wellness retreats in San Diego & Miami. Restore metabolic health and extend your healthspan."
        path="/"
        faqs={homeFaqs}
      />
      <HeroSection />
      {/* Gold divider */}
      <div className="border-t border-nav-cta/25" />
      <IntroSection />
      <div className="border-t border-nav-cta/25" />
      <ProgramsSection />
      <div className="border-t border-nav-cta/25" />
      <Suspense fallback={null}>
        <ScienceSection />
        <SkylineDivider />
        <ConciergeTravelSection />
        <div className="border-t border-nav-cta/25" />
        <LocationsSection paddingClassName="pt-12 md:pt-16 pb-10 sm:pb-12 md:pb-14 lg:pb-16"
          description="Adventure Walk Locations are intentionally selected outdoor environments where walking becomes part of the wellness experience. Each location provides an opportunity to combine movement, exploration, nature, and social connection while building cardiovascular fitness and functional strength."
        />
        <div className="border-t border-nav-cta/25" />
        <TestimonialsSection />
        <div className="border-t border-nav-cta/25" />
        <CtaBanner />
        <div className="border-t border-nav-cta/25" />
        <FaqSection />
      </Suspense>
    </main>
  );
};

export default Index;
